import { render, staticRenderFns } from "./RowBlockPaymentPenalty.vue?vue&type=template&id=754a461f&"
import script from "./RowBlockPaymentPenalty.vue?vue&type=script&lang=js&"
export * from "./RowBlockPaymentPenalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports